export const BookingTypeMetadataEditComponent = {
    template: require('./booking-type-metadata.edit.component.html'),
    controller: BookingTypeMetadataEditController,
    bindings: {
        type: '<',
        ngModel: '=',
        valid: '=',
    },
    bindToController: true,
    controllerAs: 'vm',
};

BookingTypeMetadataEditController.$inject = ['CONST', '$scope'];

/* @ngInject */
function BookingTypeMetadataEditController(CONST, $scope) {
    this.$onChanges = (changes) => changes.type && updateStructure();
    $scope.$watch('vm.form.$valid', (val) => (this.valid = val));

    const updateStructure = () => {
        const type = CONST.bookings.types.find(({ id }) => id === this.type);
        this.structure = type.metadata;
        this.validations = Object.keys(this.structure).reduce(
            (validations, field) => {
                validations[field] = new Validation(
                    this.structure[field].rules,
                );
                return validations;
            },
            {},
        );
        this.title = type.name;
    };
}

function Validation(rule) {
    const rules = (rule && rule.split('|')) || [];
    this.isNumeric = rules.includes('integer');
    this.isBoolean = rules.includes('boolean');

    if (this.isNumeric) {
        this.type = 'number';
    } else if (this.isBoolean) {
        this.options = [true, false];
        this.type = 'radio';
    } else {
        this.type = 'text';
    }
    this.required = rules.includes('required');
}

BookingTypeMetadataEditModal.$inject = ['$uibModal'];

export function BookingTypeMetadataEditModal($uibModal) {
    return {
        open: (
            booking,
            { allowCancel = false, onSave, type = booking.type },
        ) => {
            $uibModal.open({
                template: `

                    <div class="modal-body">
                        <button ng-if="$modal.allowCancel" type="button" class="close" aria-label="Close" ng-click="$modal.close()">
                            <span>&times;</span>
                        </button>
                        <booking-type-metadata-edit 
                            ng-model="$modal.model"
                            valid="$modal.valid"
                            type="$modal.type">
                        </booking-type-metadata-edit>
                    </div>
                    <div class="modal-footer">
                        <button ng-disabled="!$modal.valid" class="btn btn-primary" ng-click="$modal.save()">Guardar</button>
                    </div>
                  `,
                size: 'sm',
                backdrop: false,
                keyboard: allowCancel,
                controller: [
                    '$uibModalInstance',
                    function ($uibModalInstance) {
                        this.close = () => $uibModalInstance.close(true);
                        this.allowCancel = allowCancel;
                        this.booking = booking;
                        this.model = Object.assign({}, booking.type_metadata);
                        this.type = type;
                        this.save = () => {
                            this.booking.type_metadata = this.model;
                            $uibModalInstance.close(true);
                            onSave && onSave();
                        };
                    },
                ],
                controllerAs: '$modal',
                windowClass: 'zindex',
            });
        },
    };
}
